import { getState } from "../../store";

// ✅ 액세스 토큰
export function getAccessToken() {
  try {
    const persist = JSON.parse(localStorage.getItem("persist:root"));
    const authToken = JSON.parse(persist?.authToken || '{}');
    return authToken?.accessToken;
  } catch {
    return null;
  }
}

export function getAccessTokenFromRedux() {
  return getState().authToken?.accessToken || null;
}

// ✅ 리프레시 토큰
export function getRefreshToken() {
  try {
    const persist = JSON.parse(localStorage.getItem("persist:root"));
    const authToken = JSON.parse(persist?.authToken || '{}');
    return authToken?.refreshToken;
  } catch {
    return null;
  }
}

export function getRefreshTokenFromRedux() {
  return getState().authToken?.refreshToken || null;
}
